import React, {useEffect, useState} from 'react'
import OfferDetail from "./OfferDetail";
import {useParams} from "@reach/router";
import {getDetailById} from "../../../services/serviceOffer";

const OfferDetailContainer = () => {

    const {offerId} = useParams()
    const [offerDetail, setOfferDetail] = useState({})

    useEffect(() => {
        getDetailById(offerId)
            .then(({data}) => {
                setOfferDetail(data)
            })
    }, [])

    return(
        <React.Fragment>
            {
                offerDetail.hasOwnProperty("bid") ? <OfferDetail offer={offerDetail} /> : null
            }
        </React.Fragment>
    )
}
export default OfferDetailContainer